import { memo, useEffect, useRef } from 'react';
import { Grid } from '@quillbot/design-system';
import { ListProjects } from 'src/researcher/component/documentList/List';
import { LiveListDataLoadable } from 'src/researcher/component/documentList/LiveListData.loadable';
import { RecentTrashProjectStore } from 'src/researcher/component/documentList/list.store';
import { ConfirmBeforeDeleteProvider } from 'src/researcher/component/documentList/confirmBeforeDelete.store';
import { TemplateDemoView } from 'src/researcher/component/documentList/TemplatesDemo';
import { grow, overflowScrollAuto, w100p } from 'src/researcher/styles';
import {
  SliderVisibilityProvider,
  IsSliderShowing,
  SliderBox,
} from 'src/researcher/component/documentList/Slider';
import { pageStyles } from 'src/researcher/component/documentList/styles.css';
import { DeleteView } from 'src/researcher/component/documentList/DeleteView';
import { TrashListDataLoadable } from 'src/researcher/component/documentList/TrashListData.loadable';
import { TemplateDemoProvider } from 'src/researcher/component/documentList/template.store';
import TrackClass from 'core/logger/track';
import { useRouter } from 'next/router';
import { ListPageXPath } from 'src/researcher/constants/xpath.contants';

function LandingView() {
  return (
    <Grid container item>
      <Grid
        container
        item
        justifyContent="center"
        sx={[pageStyles.py, pageStyles.px, pageStyles.headerBg]}
        {...ListPageXPath.TemplateViewSection}
      >
        <TemplateDemoView />
      </Grid>
      <Grid
        container
        item
        justifyContent="center"
        sx={[pageStyles.py, pageStyles.px, pageStyles.listBg]}
        {...ListPageXPath.RecentViewSection}
      >
        <ListProjects />
      </Grid>
    </Grid>
  );
}

const LandingPageComponent = () => {
  const containerRef = useRef<any>(null);
  const router = useRouter();
  const pageUrl = router.pathname;

  // !Tag: Visited Co-writer
  // log visitedCoWriter page after render
  // (this avoids duplication due to refresh when user switches from micro front-end to non-mf)
  useEffect(() => {
    TrackClass.getInstance().visitedPage(pageUrl, '');
  }, []);

  return (
    /** Provides visibility of sliders */
    <SliderVisibilityProvider>
      {/* default visible on landing page */}
      {/* list project store which loads live or non-deleted projects or default landing page */}
      <RecentTrashProjectStore>
        {/* sync confirm delete dialog before across all cards and local-storage */}
        <ConfirmBeforeDeleteProvider>
          <TemplateDemoProvider>
            {/* Show slider when visible slide = "none" i.e by default */}
            <IsSliderShowing sliderId="none" sx={[grow, w100p, overflowScrollAuto]}>
              {/* loads data and when loaded mount child */}
              <LiveListDataLoadable>
                {/* rendered view after data is loaded */}
                <LandingView />
              </LiveListDataLoadable>
            </IsSliderShowing>
          </TemplateDemoProvider>
        </ConfirmBeforeDeleteProvider>

        {/* Show slider when visible slide = "trash-bin" */}
        <IsSliderShowing sliderId="trash-bin" sx={[grow, w100p]} containerRef={containerRef}>
          {/* loads data */}
          <TrashListDataLoadable>
            {/* slider-box slides-in when active */}
            <SliderBox sliderId="trash-bin" container={containerRef.current}>
              {/* rendered view after data is loaded and slide is active */}
              <Grid container item {...ListPageXPath.TrashViewSection}>
                <DeleteView />
              </Grid>
            </SliderBox>
          </TrashListDataLoadable>
        </IsSliderShowing>
      </RecentTrashProjectStore>
    </SliderVisibilityProvider>
  );
};

export const LandingPage = memo(LandingPageComponent);
